/* esm.sh - preact-feather@4.2.1 */
export * from "/v135/preact-feather@4.2.1/X-ZS9wcmVhY3Q/denonext/preact-feather.mjs";
